import { useInfiniteQuery } from "react-query";
import { variableApi } from "../services/api";
import { VariableFilters, VariableListResponse } from "../types/variable";

export const useVariablesInfinite = (
  filters: Omit<VariableFilters, "page"> = {},
) => {
  return useInfiniteQuery(
    ["variables-infinite", filters],
    ({ pageParam = 1 }) =>
      variableApi.getVariables({ ...filters, page: pageParam, page_size: 20 }),
    {
      getNextPageParam: (lastPage: VariableListResponse) => {
        if (lastPage.page < lastPage.total_pages) {
          return lastPage.page + 1;
        }
        return undefined;
      },
      keepPreviousData: true,
      staleTime: 5 * 60 * 1000,
    },
  );
};
